import React, { Component } from 'react';
import { MOBILE_MIN_HEIGHT } from 'crazyEditor/core/constants/editorConstants';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../ElementControlsStyles';
import styles from './SizeControlStyles';
import InputWrapper from 'crazyEditor/components/EditorUI/BaseUI/InputWrapper/InputWrapper';
import { updateElementSize } from 'crazyEditor/redux/modules/element/actions/elementLayoutActions';
import { lockElementAspectRatio, unlockElementAspectRatio } from 'crazyEditor/redux/modules/element/actions/elementPropsActions';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { isChildElement } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
const lockedAspectRatioIconPath = 'M9.13,5.1A3.92,3.92,0,0,0,8,8v3H6V8a6,6,0,0,1,6-6,6,6,0,0,1,6,6v3H16V8A3.92,3.92,0,0,0,14.87,5.1,4,4,0,0,0,9.13,5.1Zm7.11,15.16a6,6,0,0,1-8.48,0A5.91,5.91,0,0,1,6,16V13H8v3a3.94,3.94,0,0,0,4,4.08,3.83,3.83,0,0,0,2.86-1.17A3.92,3.92,0,0,0,16,16V13h2v3A5.91,5.91,0,0,1,16.24,20.26ZM13,8v8H11V8h2Z';
const unlockedAspectRatioIconPath = 'M17.58,19.89a6.11,6.11,0,0,1-2,1.55A5.87,5.87,0,0,1,13,22a6,6,0,0,1-4.23-1.74A5.79,5.79,0,0,1,7,16V13H9v3a3.92,3.92,0,0,0,1.13,2.91A4.06,4.06,0,0,0,13,20.12a4,4,0,0,0,1.82-.42,3.9,3.9,0,0,0,1.4-1.17L13.73,16H12V14.25L8.72,11H7V9.28l-4-4L4.27,4,21,20.73,19.74,22ZM19,11H17V8A3.93,3.93,0,0,0,15.86,5.1,4.07,4.07,0,0,0,13,3.88a4.19,4.19,0,0,0-2.29.73A4,4,0,0,0,9.23,6.41L7.78,5A5.85,5.85,0,0,1,9.94,2.8,5.91,5.91,0,0,1,13,2a6,6,0,0,1,4.25,1.74A5.8,5.8,0,0,1,19,8v3Zm-5,.2-2-2V8h2v3.2Zm5,5L17,14.3V13h2v3.18Z';
import { getSelectedElementsWithDragPosition } from 'crazyEditor/redux/modules/element/elementSelectors';

@connect(
  (state) => {
    const selectedElements = getSelectedElementsWithDragPosition(state);
    const selectedElement = selectedElements[0];
    const aspectRatio = selectedElement.layout.aspectRatio;
    const width = selectedElement.layout.width;
    const height = selectedElement.layout.height;
    return {
      viewMode: state.editor.viewMode,
      isChildElementSelected: isChildElement(selectedElement),
      aspectRatio,
      width,
      height,
    };
  },
  {updateElementSize, lockElementAspectRatio, unlockElementAspectRatio}
)
export default class SizeControl extends Component {
  constructor(props) {
    super(props);

    this.setWidth = this.setWidth.bind(this);
    this.setHeight = this.setHeight.bind(this);
  }

  setWidth(event) {
    const { updateElementSize, selectedElementIds, viewMode } = this.props;
    updateElementSize(viewMode, selectedElementIds, parseInt(event.target.value, 10), null);
  }

  setHeight(event) {
    const { updateElementSize, selectedElementIds, viewMode, isPageElement } = this.props;
    const value = parseInt(event.target.value, 10);
    if (isPageElement) {
      if (value >= MOBILE_MIN_HEIGHT) {
        updateElementSize(viewMode, selectedElementIds, null, value);
      }
    } else {
      updateElementSize(viewMode, selectedElementIds, null, value);
    }
  }

  getFullWidthOrChildElementProps(isFullWidth = false, isChild = false) {
    return {
      readOnly: isFullWidth || isChild,
      disabled: isFullWidth || isChild
    };
  }

  render() {
    const {width, height, aspectRatio, isChildElementSelected, selectedElementIds, unlockElementAspectRatio, lockElementAspectRatio, elementDefinitionProps, viewMode, isPageElement } = this.props;
    const aspectRatioDisabled = elementDefinitionProps.aspectRatioDisabled || elementDefinitionProps.autoHeight;

    const aspectRatioLocked = (
      <CustomSvgIconButton iconPath={lockedAspectRatioIconPath}
                           tooltip={!aspectRatioDisabled ? 'Unlock Aspect Ratio' : null}
                           onClick={() => unlockElementAspectRatio(viewMode, selectedElementIds)}
                           disabled={aspectRatioDisabled}
                           iconBackgroundWidth="32px"
                           iconBackgroundHeight="32px"
                           tooltipPosition="bottom-left"
      />);
    const aspectRatioUnlocked = (
      <CustomSvgIconButton iconPath={unlockedAspectRatioIconPath}
                           tooltip={!aspectRatioDisabled ? 'Lock Aspect Ratio' : null}
                           onClick={() => lockElementAspectRatio(viewMode, selectedElementIds)}
                           disabled={aspectRatioDisabled}
                           iconBackgroundWidth="32px"
                           iconBackgroundHeight="32px"
                           tooltipPosition="bottom-left"
      />);
    return (
      <div style={{...baseStyles.menuContainer, ...(this.props.first ? baseStyles.menuContainerFirst : undefined)}}>
        <div style={baseStyles.menuTitle}>Size</div>
        <div style={styles.splitter}>
          <div style={baseStyles.menuBody}>
            <div style={baseStyles.menuBodyRow}>
              <label style={baseStyles.menuBodyLabel}>W:</label>
              <InputWrapper style={baseStyles.menuBodyInput}
                            type="number"
                            value={width}
                            inputStyle={baseStyles.menuBodyInputLabel}
                            min={elementDefinitionProps.minWidth}
                            max={elementDefinitionProps.maxWidth}
                            onChange={this.setWidth}
                            {...this.getFullWidthOrChildElementProps(elementDefinitionProps.fullWidth, isChildElementSelected)}
              />
            </div>
            <div style={baseStyles.menuBodyRow}>
              <label style={baseStyles.menuBodyLabel}>H:</label>
              <InputWrapper style={baseStyles.menuBodyInput}
                            type="number"
                            value={height}
                            inputStyle={baseStyles.menuBodyInputLabel}
                            min={elementDefinitionProps.minHeight}
                            disabled={elementDefinitionProps.autoHeight || isChildElementSelected}
                            onChange={this.setHeight}
              />
            </div>
          </div>
          {(!elementDefinitionProps.fullWidth && !isPageElement) &&
          <div style={styles.aspectRatio}>
            {aspectRatio ? aspectRatioLocked : aspectRatioUnlocked}
          </div>
          }
        </div>
      </div>
    );
  }
}

SizeControl.propTypes = {
  selectedElementIds: PropTypes.array.isRequired,
  elementDefinitionProps: PropTypes.object.isRequired,
  isPageElement: PropTypes.bool.isRequired
};

SizeControl.defaultProps = {
  isPageElement: false,
};